<template>
  <div>
    <v-button
      type="button"
      :disabled="disabled"
      class="btn btn-primary w-full"
      :loading="loading"
      @click="claim"
    >
      Claim my points ({{ article.points_number }} points)
    </v-button>

    <p
      v-if="disabled"
      class="mt-1 text-sm text-center text-gray-500"
    >
      <i class="mdi mdi-information-outline" /> You must read the whole article before continuing
    </p>
  </div>
</template>
<script>
export default {
  name: "v-claim-read",
  props: {
    article: {
      type: Object,
      required: true
    },
    readingTime: {
      required: true,
      type: Number
    }
  },
  emits: ["success"],
  data () {
    return {
      loading: false,
    };
  },
  computed: {
    disabled() {
      return this.readingTime < this.article.minimum_reading_time;
    }
  },
  methods: {
    claim() {
      if (this.disabled) {
        return ;
      }

      this.loading = true;

      this.$http.post(this.$laravel.route("api.articles.claim_read",{article: this.article.id}))
        .then((response) => {
          this.$emit("success",response);
          this.$notificator.success(response.data.message);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
